import { FormattedMessage } from "react-intl";
import { Container } from "react-bootstrap";
import CONSTANTS from "../../utils/constants";
import Spinner from "react-bootstrap/Spinner";
import "./PaymentStatusPage.css";
import { getPBLData } from "../../api/apiService";
import { useParams,useNavigate } from "react-router-dom";
import { useEffect, useState, useContext, useRef } from "react";
import { UUIDContext } from "../../UUIDContexted";


export default function PaymentStatusPage() {
  const PBLData = useContext(UUIDContext);
  const { uuid } = useParams<{ uuid: string }>(); 
  const navigate = useNavigate();
  const [retryWithOtherMethod, setRetryWithOtherMethod] = useState(false);
  const retryCountRef = useRef(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const hasNavigatedRef = useRef(false);
  const startTimeRef = useRef(Date.now());
  const showButtonTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const navigateToShop = () => {
    if (PBLData?.returnUrl) {
      window.location.href = PBLData.returnUrl;
    }
  }

  useEffect(() => {
    if (!uuid) return;
  
    const RETRY_DELAYS = [3000, 4000, 8000, 15000, 15000, 15000];
    let cancelled = false;
  
    const loadPBLData = async () => {
      if (cancelled || hasNavigatedRef.current) return;

      try {
        const response = await getPBLData(uuid);
        if (cancelled || hasNavigatedRef.current) return;
  
        const httpStatus = response?.status;
        const pblStatus = response?.data?.status;
  
        if (pblStatus === "PAID") {
          hasNavigatedRef.current = true;
          if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
          }
          navigate(`/${uuid}/success`);
          return;
        }
  
        if (pblStatus === "REDIRECTED") {

          const elapsedTime = Date.now() - startTimeRef.current;
          if (elapsedTime >= 10000) {
            setRetryWithOtherMethod(true);
          } else {
            if (!showButtonTimeoutRef.current) {
              const remaining = 10000 - elapsedTime;
        
              showButtonTimeoutRef.current = setTimeout(() => {
                setRetryWithOtherMethod(true);
              }, remaining);
            }
          }
          if (retryCountRef.current < RETRY_DELAYS.length) {
            const delay = RETRY_DELAYS[retryCountRef.current++];
            timeoutRef.current = setTimeout(loadPBLData, delay);
            return;
          }
          return;
        }
  
        if (httpStatus >= 200 && httpStatus < 300) {
          hasNavigatedRef.current = true;
          navigate(`/${uuid}`);
        } else {
          hasNavigatedRef.current = true;
          navigate(`/${uuid}/error`);
        }
      } catch {
        if (!cancelled) {
          hasNavigatedRef.current = true;
          navigate(`/${uuid}/error`);
        }
      }
    };
  
    loadPBLData();
  
    return () => {
      cancelled = true;
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      } 
      if (showButtonTimeoutRef.current) {
        clearTimeout(showButtonTimeoutRef.current);
      }
    };
  }, [uuid, navigate]);
  
  return (
    <Container className="d-flex justify-content-center align-items-center">
      <div className="d-flex flex-column align-items-center text-center">
        <div className="main-spinner-wrapper">
        <Spinner
              animation="border"
              role="status"
                className="main-spinner mb-2"
          ></Spinner> 
        </div>
        <div className="text-center success-msg">
          <h3 className="message-payment mb-0" data-testid="successPage-paymentSuccessful-message"  style={{color: "#0096d6"}}>
          <FormattedMessage
                id={CONSTANTS.PAYMENT_STATUS.DISPLAY_MESSAGE.PAYMENT_PROCESSING}
                defaultMessage="Your payment is being processed"
              />
          </h3>            
          <p className="message-transaction mb-2" data-testid="successPage-transaction-message">
          <FormattedMessage
                id={CONSTANTS.PAYMENT_STATUS.DISPLAY_MESSAGE.PLEASE_WAIT}
                defaultMessage="Please do not close this window or navigate away from this page."
              />
          </p>

          <nav className="d-flex flex-wrap justify-content-center gap-2" aria-label="Post-payment actions" role="group">
          {
            retryWithOtherMethod &&
            <button
              className="btn btn-outline-danger  px-4 rounded-4 mt-3 text-center"
              onClick={() => navigate(`/${uuid}/`)}
              data-testid="pm-retry-with-other-method-btn" 
            >
            <FormattedMessage
                id={CONSTANTS.BUTTON.RETRY_PAYMENT_METHOD}
                defaultMessage="Pay with other payment method"
              />
            
            </button>
            }


          {PBLData && PBLData.returnUrl && PBLData.returnUrl !== "" ?
            <button
              className="btn btn-outline-secondary px-4 rounded-4 back-to-shop-btn mt-3"
              onClick={navigateToShop}
              data-testid="pm-back-to-shop-btn"
            >
              <FormattedMessage
                id={CONSTANTS.BUTTON.BACK_TO_THE_SHOP}
                defaultMessage="Back to the shop"
              />
            </button>
            : null
          }
          </nav>

          
        </div>
      </div>
    </Container>
  )
}